/**
 * Normaliza el objeto schedule de un tipo de cita (appointment_types.schedule).
 * @param {object|null|undefined} data
 */
export function normalizeScheduleFromApi(data) {
  const raw = data && typeof data === 'object' ? data : {};
  const base = {
    opening_time: raw.opening_time || '09:00',
    closing_time: raw.closing_time || '17:00',
    lunch_start: raw.lunch_start || '14:00',
    lunch_end: raw.lunch_end || '15:00',
    working_days: Array.isArray(raw.working_days) ? [...raw.working_days] : [1, 2, 3, 4, 5],
    appointment_duration: raw.appointment_duration != null ? Number(raw.appointment_duration) : 30,
    per_day: {},
  };
  const fallbackDay = () => ({
    opening_time: base.opening_time,
    closing_time: base.closing_time,
    lunch_start: base.lunch_start,
    lunch_end: base.lunch_end,
  });
  for (let d = 1; d <= 7; d++) {
    const k = String(d);
    const incoming = raw.per_day && raw.per_day[k];
    base.per_day[k] = incoming
      ? {
          opening_time: incoming.opening_time || base.opening_time,
          closing_time: incoming.closing_time || base.closing_time,
          lunch_start: incoming.lunch_start || base.lunch_start,
          lunch_end: incoming.lunch_end || base.lunch_end,
        }
      : fallbackDay();
  }
  return base;
}

const DAY_NAMES = {
  1: 'Lunes',
  2: 'Martes',
  3: 'Miércoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sábado',
  7: 'Domingo',
};

function sameScheduleBlock(a, b) {
  if (Boolean(a.work) !== Boolean(b.work)) return false;
  if (!a.work) return true;
  return (
    a.open === b.open &&
    a.close === b.close &&
    a.ls === b.ls &&
    a.le === b.le
  );
}

function rangeLabel(group) {
  if (group.length === 1) return group[0].name;
  return `${group[0].name} a ${group[group.length - 1].name}`;
}

/**
 * Textos de horario para un servicio (contacto, pie de página).
 * @param {object|null|undefined} scheduleRaw schedule del tipo de cita
 * @returns {string[]}
 */
export function buildFooterScheduleLines(scheduleRaw) {
  const s = normalizeScheduleFromApi(scheduleRaw);
  const dayMeta = [];
  for (let d = 1; d <= 7; d++) {
    const work = s.working_days.includes(d);
    const pd = s.per_day[String(d)];
    dayMeta.push({
      d,
      name: DAY_NAMES[d],
      work,
      open: pd.opening_time,
      close: pd.closing_time,
      ls: pd.lunch_start,
      le: pd.lunch_end,
    });
  }

  const groups = [];
  let i = 0;
  while (i < 7) {
    let j = i + 1;
    while (j < 7 && sameScheduleBlock(dayMeta[i], dayMeta[j])) j++;
    groups.push(dayMeta.slice(i, j));
    i = j;
  }

  const lines = [];
  for (const g of groups) {
    const cur = g[0];
    if (!cur.work) {
      lines.push(`${rangeLabel(g)}: Cerrado`);
    } else {
      lines.push(`${rangeLabel(g)}: ${cur.open} – ${cur.close}`);
      lines.push(`Comida: ${cur.ls} – ${cur.le}`);
    }
  }
  return lines;
}
